import { render, staticRenderFns } from "./star_assignment_page.vue?vue&type=template&id=704c5934&scoped=true"
import script from "./star_assignment_page.vue?vue&type=script&lang=js"
export * from "./star_assignment_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704c5934",
  null
  
)

export default component.exports